<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/insbillpay/getlist"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="audit(row)"
            >审核</el-button
          >
        </template>
      </BaseTable>

    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Issue",
  comments: {},
  data() {
    return {
      searchData: {status:7},
      tableData: [],
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {},
  methods: {
    audit(row) {
          this.$confirm("是否确认提交, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
              await this.$api.post(
                "/admin/insbillpay/issueSubmit",
                {insBillId:row.insBillId},
                "交费"
              );
              this.dialogVisible = false;
              this.handleSearch();
            }).catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      return {
        ...params,
        ...this.searchData,
      };
    },

  },
};
</script>
<style scoped lang="scss">
	.row-left {
		float:left;
		width:60%;
		fonst-size:16px;
		color: black;
		div {
			height:33px;
		}
	}
	.row-right {
		float:left;
		width:40%;
		text-align: center;
	}
	.qr-code {
		width: 180px;
		height: 180px;
	}
	.wxpay-img {
		width: 30px;
		height: 30px;
		margin-right: 30px;
		margin-top: 10px;
	}
	.zfbpay-img {
		width: 30px;
		height: 30px;
		margin-top: 10px;
	}
</style>